import { render, staticRenderFns } from "./TourismNewsList.vue?vue&type=template&id=0751ea66&scoped=true&"
import script from "./TourismNewsList.vue?vue&type=script&lang=js&"
export * from "./TourismNewsList.vue?vue&type=script&lang=js&"
import style0 from "./TourismNewsList.vue?vue&type=style&index=0&id=0751ea66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0751ea66",
  null
  
)

export default component.exports